import { useEffect, useState } from "react";
import Shell from "../../components/Shell";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Calendar, MapPin, Users, Check } from "lucide-react";

export default function ClinicEvents() {
    const [events, setEvents] = useState([]);

    const reload = () => api.get("/events").then(r => setEvents(r.data || [])).catch(() => {});
    useEffect(() => { reload(); }, []);

    const register = async (id) => {
        try { await api.post(`/events/${id}/register`); toast.success("Registered"); reload(); }
        catch (err) { toast.error(formatApiError(err)); }
    };
    const unregister = async (id) => {
        try { await api.delete(`/events/${id}/register`); toast.success("Cancelled"); reload(); }
        catch (err) { toast.error(formatApiError(err)); }
    };

    return (
        <Shell variant="clinic">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 py-10 animate-fade-in">
                <p className="eyebrow mb-2">Training & events</p>
                <h1 className="font-heading text-3xl sm:text-4xl font-light tracking-tight mb-2">Upcoming sessions</h1>
                <p className="text-sm text-zinc-500 mb-10">In-clinic training, masterclasses and brand events for approved Dermalis partners.</p>

                {events.length === 0 ? (
                    <div className="text-center py-20 border border-dashed border-zinc-200 rounded-sm">
                        <p className="text-sm text-zinc-500">No upcoming events yet. Dermalis will publish sessions here.</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="events-list">
                        {events.map(ev => (
                            <article key={ev.id} className="card-base p-6 flex flex-col">
                                <p className="eyebrow mb-2">{ev.upcoming ? "Upcoming" : "Past"}</p>
                                <h3 className="font-heading text-xl mb-3">{ev.title}</h3>
                                <p className="text-sm text-zinc-600 mb-4 flex-1">{ev.description}</p>
                                <ul className="text-xs text-zinc-500 space-y-1.5 mb-5 border-t border-zinc-100 pt-4">
                                    <li className="flex items-center gap-2"><Calendar size={13} strokeWidth={1.5} /> {new Date(ev.starts_at).toLocaleString()}</li>
                                    {ev.location && <li className="flex items-center gap-2"><MapPin size={13} strokeWidth={1.5} /> {ev.location}</li>}
                                    {ev.capacity > 0 && <li className="flex items-center gap-2"><Users size={13} strokeWidth={1.5} /> {ev.registrations_count}/{ev.capacity}</li>}
                                </ul>
                                {ev.registered ? (
                                    <button data-testid={`event-cancel-${ev.id}`} onClick={() => unregister(ev.id)} className="btn-secondary"><Check size={14} strokeWidth={1.5} /> Registered — cancel</button>
                                ) : (
                                    <button data-testid={`event-register-${ev.id}`} onClick={() => register(ev.id)} disabled={!ev.upcoming || (ev.capacity > 0 && ev.registrations_count >= ev.capacity)} className="btn-primary">{ev.capacity > 0 && ev.registrations_count >= ev.capacity ? "Fully booked" : "Register"}</button>
                                )}
                            </article>
                        ))}
                    </div>
                )}
            </div>
        </Shell>
    );
}
